import { render, staticRenderFns } from "./main.vue?vue&type=template&id=58838244&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=58838244&prod&scoped=true&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=58838244&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58838244",
  null
  
)

export default component.exports